import { render, staticRenderFns } from "./SixteenTable.vue?vue&type=template&id=5ee76967&"
import script from "./SixteenTable.vue?vue&type=script&lang=js&"
export * from "./SixteenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports